<template>
  <slot></slot>
</template>

<script setup>
import { importSharerJs, initSharrerWatch } from './importSharerJs.js';
importSharerJs();
initSharrerWatch();
</script>
